import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return '';
  }

  const date = dayjs(dateString);
  return date.isValid() ? date.format('YYYY-MM-DD') : '';
};

export const formatDateTimeForInput = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return '';
  }

  const date = dayjs(dateString);
  return date.isValid() ? date.format('YYYY-MM-DDTHH:mm') : '';
};

export const convertUTCToLocalForInput = (utcDateString: string | null | undefined): string => {
  if (!utcDateString) {
    return '';
  }

  // Add null safety: Validate date before processing
  const date = dayjs.utc(utcDateString);
  if (!date.isValid()) {
    return '';
  }

  const localDate = date.local();
  return localDate.format('YYYY-MM-DDTHH:mm');
};

export const convertLocalToUTC = (localDateTimeString: string): string => {
  if (!localDateTimeString) {
    return '';
  }

  const date = dayjs(localDateTimeString);
  if (!date.isValid()) {
    return '';
  }

  return date.utc().toISOString();
};

export const formatUTCForDisplay = (
  utcDateString: string | null | undefined,
  showTimezone: boolean = true
): string => {
  if (!utcDateString) {
    return '';
  }

  const date = dayjs.utc(utcDateString);
  if (!date.isValid()) {
    return 'Invalid Date';
  }

  const localDate = date.local();
  const baseFormat = 'MM/DD/YYYY, hh:mm:ss A';

  if (showTimezone) {
    // Get timezone abbreviation
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return `${localDate.format(baseFormat)} (${timezone})`;
  }

  return localDate.format(baseFormat);
};
